/**
 * useSoundInitialization — Initializes SoundManager on first user interaction
 *
 * Browsers require AudioContext creation inside a user-gesture handler
 * (autoplay policy). This hook registers click/keydown/touchstart listeners
 * and removes them after the first interaction.
 */

import { useEffect } from 'react';
import { soundManager } from '@/services/SoundManager';

export function useSoundInitialization(): void {
  useEffect(() => {
    const initSound = () => {
      soundManager.initialize();
      document.removeEventListener('click', initSound);
      document.removeEventListener('keydown', initSound);
      document.removeEventListener('touchstart', initSound);
    };
    document.addEventListener('click', initSound);
    document.addEventListener('keydown', initSound);
    document.addEventListener('touchstart', initSound);
    return () => {
      document.removeEventListener('click', initSound);
      document.removeEventListener('keydown', initSound);
      document.removeEventListener('touchstart', initSound);
    };
  }, []);
}
